export default __webpack_public_path__ + "static/media/icon-info-circle.a7e96ede.svg";